import { useMutation, useQueryClient } from 'react-query'
import { TrackedChangeComment } from 'types'
import { trackedChangeCommentsKeys } from './trackedChangeCommentsKeys'

import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { trackedChangesKeys } from '../trackedChanges/trackedChangesKeys'
import { buildErrorMessage } from 'utils'

interface Props {
  articleKey: string
  layerId: string
  trackedChangeId: string
}

interface InputPayload {
  body: string
  html_body: string | null
}

interface ResponseData {
  comment: TrackedChangeComment
}

export const useCreateTrackedChangeComment = ({ articleKey, layerId, trackedChangeId }: Props) => {
  const queryClient = useQueryClient()

  return useMutation<ResponseData, Error, InputPayload>(
    trackedChangeCommentsKeys.create(trackedChangeId),
    async (payload) => {
      const response = await sendToApi<ResponseData>(
        `/articles/${articleKey}/layers/${layerId}/changes/${trackedChangeId}/comments`,
        {
          method: 'POST',
          body: { comment: payload },
        },
      )

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }

      return response.data
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(trackedChangesKeys.list(layerId, {}))
      },
    },
  )
}
